import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { bundleInfoSchema } from "./bundle-info";

export const getBundlesData = {
  name: "getBundlesData" as const,
  input: z.object({
    teamId: z.string(),
    pageSize: z.number(),
    pageContinue: z.number(),
    /** Case-insensitive match on the bundle name or any item name. */
    query: z.string().nullish(),
  }),
  output: z.object({
    bundles: z.array(bundleInfoSchema),
    enabledReturnTypes: z.array(createEnum(ReturnTypeEnum)),
    pageNext: z.number().nullish(),
    /** Every bundle the team has, ignoring `query`. */
    totalCount: z.number(),
    /** Bundles that match `query`; equals `totalCount` without one. */
    matchedCount: z.number(),
  }),
};
